import axios from 'axios';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Col, Form } from 'react-bootstrap';
import DefaultLoader from '../../components/loader/DefaultLoader';
import SeriesBatterList from '../../components/playerList/SeriesBatterList';
import SeriesPitcherList from '../../components/playerList/SeriesPitcherList';
import {useCookies} from 'react-cookie';
import NextPitcher from './sub/NextPitcher';
import NextBatter from './sub/NextBatter';
import dateSetting from '../../utils/dateSetting';
import { useTranslation } from 'react-i18next';

function SeriesMain({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [teamArr, setTeamArr] = useState([]);
    let {type} = profile;
    const { t } = useTranslation();
    let useLang = localStorage.getItem('language');

    let [currCheck, setCurrCheck] = useState(false);
    let [nextCheck, setNextCheck] = useState(false);

    useEffect(() => {
        let dateObj = dateSetting();
        let {teamId} = profile;

        let params = {
            recordType: 'digestRecord',
            seasons: dateObj['season'],
            gameDay: dateObj['todayString'],
            gameTypeCode: 4201,
            authToken:JSON.stringify(cookies['hiball_token'])
        }

        if(type === 'batter') {
            params['recordName'] = 'selectNextMatchPitcher';
            params['batterTeamIds'] = teamId;
        } else {
            params['recordName'] = 'selectNextMatchBatter';
            params['pitcherTeamIds'] = teamId;
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: params
        }).then((result) => {
            let nextMatch = result['data']['result'];
            let sortData = _.sortBy(nextMatch, 'gameDay');

            let firstTeam = sortData[0] ? sortData[0]['oppTeamId'] : 0;
            let firstTeamName = sortData[0] 
                    ? (useLang === "en" ? sortData[0]['englishOppTeamName']  : sortData[0]['oppTeamName'])
                    : '없음';
            let secondTeam = 0;
            let secondTeamName = '없음';

            if(firstTeam !== 0) {
                _.forEach(sortData, (item, idx) => {
                    if(firstTeam !== item['oppTeamId']*1) {
                        secondTeam = item['oppTeamId'];
                        if(useLang === "en"){
                            //영어일 경우
                            secondTeamName = item['englishOppTeamName'];
                        } else {
                            //한국어일 경우 또는 language 값이 없을 경우
                            secondTeamName = item['oppTeamName'];
                        }
                        return false;
                    }
                });
            }

            setTeamArr(...teamArr, [{teamId: firstTeam, teamName: firstTeamName}, {teamId: secondTeam, teamName: secondTeamName}]);
        });
    }, []);

    function checkboxClickHandler(e) {
        let checkBoxId = e.currentTarget.id;
        if(checkBoxId === 'currSeries-checkbox') {
            setCurrCheck(e.currentTarget.checked);
        } else { //next
            setNextCheck(e.currentTarget.checked);
        }
    }

    if(teamArr.length === 0) {
        return <DefaultLoader />
    }

    return (
    <>  
        {
            type === 'batter' ?
            <>
            <Col id="currSeries" className="digestDivBox" style={{position:'relative'}}>
                <div style={{position:'absolute', top: '7px'}}>
                    <Form>
                        <div key={`default-checkbox`} className="mb-3">
                            <Form.Check 
                                type={'checkbox'}
                                id={`currSeries-checkbox`}
                                label={t('vsPitcher')}
                                onClick={checkboxClickHandler}
                                defaultChecked={currCheck}
                                style={useLang === "en" ? {fontSize:"15px", marginTop:"5px"} : {}}
                            />
                        </div>
                    </Form>
                </div>
                <div className="boxTitle">
                    {t('thisSeries')} : {teamArr[0]['teamName']}
                </div>
                <SeriesPitcherList teamObj={teamArr[0]} title={'starter'} 
                pitcherType={5102} checked={currCheck} profile={profile}/>
                <SeriesPitcherList teamObj={teamArr[0]} title={'bullpen'} 
                pitcherType={5104} checked={currCheck} profile={profile}/>
            </Col>
            <Col id="nextSeries" className="digestDivBox" style={{position:'relative'}}>
                <div style={{position:'absolute', top: '7px'}}>
                    <Form>
                        <div key={`default-checkbox`} className="mb-3">
                            <Form.Check 
                                type={'checkbox'}
                                id={`nextSeries-checkbox`}
                                label={t('vsPitcher')}
                                onClick={checkboxClickHandler}
                                defaultChecked={nextCheck}
                                style={useLang === "en" ? {fontSize:"15px", marginTop:"5px"} : {}}
                            />
                        </div>
                    </Form>
                </div>
                <NextPitcher teamObj={teamArr[1]} 
                checked={nextCheck} profile={profile}></NextPitcher>
            </Col>
            </>
             :
            <>
            <Col id="currSeries" className="digestDivBox" style={{position:'relative'}}>
                <div style={{position:'absolute', top: '7px'}}>
                    <Form>
                        <div key={`default-checkbox`} className="mb-3">
                            <Form.Check 
                                type={'checkbox'}
                                id={`currSeries-checkbox`}
                                label={t('vsBatter')}
                                onClick={checkboxClickHandler}
                                defaultChecked={currCheck}
                                style={useLang === "en" ? {fontSize:"15px", marginTop:"5px"} : {}}
                            />
                        </div>
                    </Form>
                </div>
                <div className="boxTitle">
                    {t('thisSeries')} : {teamArr[0]['teamName']}    
                </div>
                <SeriesBatterList teamObj={teamArr[0]} title={'이번 시리즈'}
                checked={currCheck} profile={profile}/>
            </Col>
            <Col id="nextSeries" className="digestDivBox" style={{position:'relative'}}>
                <div style={{position:'absolute', top: '7px'}}>
                    <Form>
                        <div key={`default-checkbox`} className="mb-3">
                            <Form.Check 
                                type={'checkbox'}
                                id={`nextSeries-checkbox`}
                                label={t('vsBatter')}
                                onClick={checkboxClickHandler}
                                defaultChecked={nextCheck}
                                style={useLang === "en" ? {fontSize:"15px", marginTop:"5px"} : {}}
                            />
                        </div>
                    </Form>
                </div>
                <NextBatter teamObj={teamArr[1]}
                checked={nextCheck} profile={profile}></NextBatter>
            </Col>
            </>
        }
    </>
    )
}

export default SeriesMain;